// extracted by mini-css-extract-plugin
export default {"header":"MainNavigation_header__GJCvR","pages":"MainNavigation_pages__j+LwM"};